"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDashboardTasksQueryParamsSync = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const dashboard_tasks_query_params_hydrators_map_1 = require("./dashboard-tasks-query-params-hydrators.map");
const dashboard_tasks_query_params_constants_1 = require("./dashboard-tasks-query-params.constants");
const dashboard_tasks_query_params_mappers_1 = require("./dashboard-tasks-query-params.mappers");
const view_query_params_1 = require("../../../../common/view-query-params");
const selectors_1 = require("../../../../store/catalogs/dashboards/selectors");
const store_1 = require("../../../../../store");
const useDashboardTasksQueryParamsSync = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const catalogId = (0, store_1.useSelectedCatalogId)();
    const projectId = (0, store_1.useSelectedProjectId)();
    const filter = (0, selectors_1.usePriorityTasksTableFilter)();
    const sort = (0, selectors_1.usePriorityTasksTableSort)();
    const pageSize = (0, selectors_1.usePriorityTasksTablePageSize)();
    const viewState = (0, react_1.useMemo)(() => (0, dashboard_tasks_query_params_mappers_1.getDashboardTasksQueryState)({
        catalogId,
        filter,
        pageSize,
        projectId,
        sort,
    }), [catalogId, filter, pageSize, projectId, sort]);
    const handleHydrate = (0, react_1.useCallback)((state) => {
        if (!catalogId)
            return;
        (0, dashboard_tasks_query_params_hydrators_map_1.hydrateDashboardTasksQueryState)({
            catalogId,
            dispatch,
            state,
        });
    }, [catalogId, dispatch]);
    const shouldHydrate = (0, react_1.useCallback)((state) => (state[view_query_params_1.ViewQueryStateField.ProjectId] === projectId
        && state[view_query_params_1.ViewQueryStateField.CatalogId] === catalogId), [catalogId, projectId]);
    return (0, view_query_params_1.useViewQueryParamsSync)({
        defaults: dashboard_tasks_query_params_constants_1.dashboardTasksQueryStateDefaults,
        enabled: Boolean(projectId && catalogId),
        onHydrate: handleHydrate,
        shouldHydrate,
        viewState,
    });
};
exports.useDashboardTasksQueryParamsSync = useDashboardTasksQueryParamsSync;
